import { AxiosError } from 'axios'
import { httpClient } from 'shared/lib'

import consoleMessage from 'shared/utils/helpers/consoleMessage'
import isAxiosError from 'shared/utils/helpers/isAxiosError'

export function newPasswordService(token: string, payload: NewPasswordPayloadType) {
   let errMessage = ''

   return httpClient
      .post<Result>(`users/reset-password/${token}`, payload)
      .then((res) => ({ status: res.status }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('RESET_PASSWORD newPassword service', errMessage, 'error')
         throw error
      })
}
